import NetworkingOperations from "../index";

const PaymentSubmit = (data) => {
	const url = process.env.REACT_APP_PAYMENT_SUBMIT;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentSubmit;
